import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shared/components/ui/shadcn/select';
import { useTranslation } from 'react-i18next';
import type { ShipmentStatus } from '../../models/shipmentStatusMapping.types';

interface InternalStatusPickerProps {
  shipmentStatuses: ShipmentStatus[];
  selectedStatusId: string;
  onSelect: (statusId: string) => void;
  allowNone?: boolean;
  noneValue?: string;
  testIdPrefix?: string;
}

export const InternalStatusPicker = ({
  shipmentStatuses,
  selectedStatusId,
  onSelect,
  allowNone = false,
  noneValue = 'none',
  testIdPrefix = 'status-picker',
}: InternalStatusPickerProps) => {
  const { t } = useTranslation('shipmentStatusMappingModule');

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-foreground" htmlFor={`${testIdPrefix}-select`}>
        {t('shipmentStatusMapping.modal.internalStatus')}
      </label>
      <Select value={selectedStatusId || undefined} onValueChange={onSelect}>
        <SelectTrigger id={`${testIdPrefix}-select`} className="w-full" data-testid={`${testIdPrefix}-select`}>
          <SelectValue placeholder={t('shipmentStatusMapping.modal.selectInternalStatus')} />
        </SelectTrigger>
        <SelectContent>
          {allowNone && (
            <SelectItem value={noneValue} data-testid={`${testIdPrefix}-none`}>
              {t('shipmentStatusMapping.table.noMapped')}
            </SelectItem>
          )}
          {shipmentStatuses.map((status) => (
            <SelectItem key={status.id} value={status.id.toString()} data-testid={`${testIdPrefix}-${status.id}`}>
              {status.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
